import script from "./UserInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=9953e8a0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src014250190/src/byggesoknaden-support-gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9953e8a0"]])

export default __exports__